import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import type {
  HomepagePromoBannerData,
  HomepagePromoBannerVariant,
  HomepagePromoBannerTestResult,
  UseHomepagePromoBanner,
} from "./types";

const CUSTOM_RULE_ID = "homepagePromoBanner";

/**
 * Hook for the homepage promo banner experiment.
 * This experiment can return one of the following variants:
 * - homepagePromoBannerControl: Image-right CTA with fields coming from the CMS
 * - homepagePromoBannerVariantA: PromoBanner with fields coming from Monarch
 */
const useHomepagePromoBanner: UseHomepagePromoBanner = () => {
  // Call the Monarch API to get the experiment result
  const { isLoading, value } = useMonarchRule<{
    data: HomepagePromoBannerData;
    variantCustomId: HomepagePromoBannerVariant;
  }>(CUSTOM_RULE_ID, {});

  // If still loading or no value returned, return loading state
  if (isLoading || !value) {
    return {
      isLoading,
    } as HomepagePromoBannerTestResult;
  }

  // Return the experiment result with proper typing
  return {
    isLoading: false,
    variant: value.variantCustomId,
    data: value.data,
  };
};

export default useHomepagePromoBanner;
